export * from '@primeuix/themes/material/multiselect';
export { default } from '@primeuix/themes/material/multiselect';
